import { Component, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { BuildingAmenityData } from '@artemis-software/wr-api';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { createForm } from '@sonofabit/ng-core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: false,
  selector: 'wr-building-amenity-form',
  templateUrl: './building-amenity-form.component.html',
  styleUrl: './building-amenity-form.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BuildingAmenityFormComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BuildingAmenityFormComponent),
      multi: true,
    }
  ],
})
export class BuildingAmenityFormComponent extends AbstractFormControl<BuildingAmenityData> implements Validator {

  readonly form = createForm(({ field }) => {
    return {
      businesses: field({ value: '' as string | null }),
      heatingSystem: field({ value: '' as string | null }),
      playground: field({ value: '' as string | null }),
      garageCount: field({ value: null as number | null }),
      undergroundGarageCount: field({ value: null as number | null }),
      flatCount: field({ value: null as number | null }),
      convertedAttic: field({ value: null as any }),
    };
  });

  constructor() {
    super();
    this.form.valueChanges.pipe(takeUntilDestroyed()).subscribe(val => {
      this.value = val as BuildingAmenityData;
      this.onValidatorChange?.();
    });
  }

  override setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable({ emitEvent: false });
    } else {
      this.form.enable({ emitEvent: false });
    }
  }

  override writeValue(value: BuildingAmenityData | undefined) {
    super.writeValue(value);
    if (value) {
      this.form.patchValue(value, { emitEvent: false });
    } else {
      this.form.reset({}, { emitEvent: false });
    }
  }

  override markAsTouched() {
    super.markAsTouched();
    this.form.markAllAsTouched();
  }

  validate(_control: AbstractControl): ValidationErrors | null {
    return this.form.invalid ? { amenityDataInvalid: true } : null;
  }

  private onValidatorChange?: () => void;
  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }
}
